import { ExitToApp } from "@mui/icons-material";
import {
  Card,
  CardHeader,
  ClickAwayListener,
  Fade,
  IconButton,
  Popper,
  Tooltip
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { MemberAvatar } from "features/solution-member";
import { useRef, useState } from "react";

const useStyles = makeStyles(theme => ({
  paddingLeft: { paddingLeft: theme.spacing(2) },
  popper: {
    top: "10px !important",
    right: 8,
    zIndex: 1000,
    left: "unset !important"
  },
  cursor: { cursor: "pointer" },
  logoutIcon: { color: "#ffb900" }
}));

export type UserInfo = {
  name: string;
  familyName: string;
  email: string;
  signOut: () => void;
};

export default function UserGreeting(props: UserInfo) {
  const { paddingLeft, popper, cursor, logoutIcon } = useStyles({});

  const { name: firstName, familyName: lastName, email, signOut } = props;
  const user = { firstName, lastName };

  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={paddingLeft}>
        <button
          type="button"
          aria-label="Toggle user menu"
          onClick={handleToggle}
          className={cursor}
          ref={anchorRef}
          style={{ background: "none", border: "none", padding: 0 }}
        >
          <MemberAvatar large dataTest="logged-in-user" member={user} />
        </button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          className={popper}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Card>
                <CardHeader
                  avatar={<MemberAvatar aria-label="recipe" member={user} />}
                  action={
                    <Tooltip title="Sign Out">
                      <IconButton
                        data-test="sign-out-button"
                        aria-label="settings"
                        onClick={signOut}
                        size="large"
                      >
                        <ExitToApp className={logoutIcon} />
                      </IconButton>
                    </Tooltip>
                  }
                  title={`${firstName} ${lastName}`}
                  subheader={email}
                />
              </Card>
            </Fade>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
}
